import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cmsClient } from "src/services/cmsClient";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

const deleteObservationCategory = async ({ id }: { id: number }) => {
	const url = `/observations/admin/forms/categories/${id}/`;
	const response = await cmsClient.delete(url);

	return response.data;
};

const useDeleteObservationCategory = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["observation-categories"]);

		toast.success(
			<CustomToast type="Success" message="Category deleted successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutationFn = deleteObservationCategory;

	const mutation = useMutation({
		mutationFn,
		onSuccess,
		onError
	});

	return mutation;
};

export default useDeleteObservationCategory;
